import { baseApi } from "@/app/store/baseApi";

export interface Branch {
  id: string;
  name: string;
  code: string;
  address: string;
}

export const branchesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    listBranches: builder.query<Branch[], void>({
      query: () => ({ url: "/branches", auth: true }),
      providesTags: [{ type: "Branch", id: "LIST" }],
    }),
  }),
});

export const { useListBranchesQuery } = branchesApi;
